export const redirectWithPayload = (url = "", payload = {}) => {
  
  const f = document.createElement('form');
  f.method = 'post';
  f.action = url;

  Object.keys(payload).forEach(function(key) {
    const i  = document.createElement('input');
    i.name = key;
    i.type = 'hidden'
    i.value = payload[key];
    
    f.appendChild(i);
    

  })

  document.body.appendChild(f);

  f.submit();
}

export const postToUrl = (url = "", payload = {}) => {
    return fetch(url,
        {
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            method: "POST",
            credentials: "same-origin"
        });
}


// WEBPACK FOOTER //
// ./src/Components/util/apiUtils.js